import { useQuery } from "@tanstack/react-query";

import type { DesktopBridge } from "./bridge.js";

/**
 * A printer picker backed by the OS's printer list (`window.desktop.printers`).
 * `null` means "use the OS default printer" — the same meaning `printerName`
 * carries in `DesktopSettings`, and the first option here. Silent printing
 * (`printing.ts`) drives whichever name this resolves to.
 */
export function PrinterSelect({
  bridge,
  value,
  onChange,
  id = "printer",
}: {
  bridge: DesktopBridge;
  value: string | null;
  onChange: (printerName: string | null) => void;
  id?: string;
}) {
  const printersQuery = useQuery({
    queryKey: ["desktop-printers"],
    queryFn: () => bridge.printers.list(),
  });

  const printers = printersQuery.data ?? [];
  // A saved printer the OS no longer reports still needs to show, so the
  // operator can see what is configured rather than have it silently reset.
  const missingSaved = value !== null && !printers.some((p) => p.name === value);

  return (
    <select id={id} className="settings-select" value={value ?? ""} onChange={(e) => onChange(e.target.value === "" ? null : e.target.value)}>
      <option value="">Privzeti tiskalnik sistema</option>
      {printers.map((printer) => (
        <option key={printer.name} value={printer.name}>
          {printer.displayName || printer.name}
          {printer.isDefault ? " (privzeti)" : ""}
        </option>
      ))}
      {missingSaved && <option value={value}>{value} (ni na voljo)</option>}
    </select>
  );
}
